// removed by extract-text-webpack-plugin
module.exports = {"close":"src-components-Modal----Modal-module---close---3VJL0","content":"src-components-Modal----Modal-module---content---I6vZk","modal":"src-components-Modal----Modal-module---modal---FqeFw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.module.scss
// module id = 122
// module chunks = 29990747609436 213534597649335